import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { ThemePalette } from '@angular/material/core';
import { takeUntil } from 'rxjs/operators';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss']
})
export class CustomButtonComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() show = true;
  @Input() type: 'raised' | 'stroked' | 'flat' | 'menu' = 'flat';
  @Input() color: ThemePalette = 'primary';
  @Input() spinner = false;
  @Input() disable = false;
  @Input() infoInButton: string = null;
  @Output() onClick = new EventEmitter<any>();

  @Input() tooltip: string = null;

  private compUnsubs$ = new Subject<void>();

  public disabledButton = false;

  constructor(private dataShareService: DataShareService) {}

  ngOnInit(): void {
    this.dataShareService.isLoading$.pipe(takeUntil(this.compUnsubs$)).subscribe((isLoading) => {
      this.disabledButton = isLoading;
    });
  }

  sendClick() {
    this.onClick.emit();
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
